module.exports = __webpack_public_path__ + "stylesheets/edu_79af8a19a747b6287d49c4fd17609ba5.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/edu.less
// module id = TBjL
// module chunks = 151